// @ts-nocheck

import memoize from 'memoize-state';
import React from 'react';
import { useSelector } from 'react-redux';

import useMergeProps from '../../../hooks/useMergeProps';
import GridsAuthor from '../components/public/GridsAuthor';
import { getAuthor } from '../selectors/common';

const legacySelector = memoize(getAuthor);

type GridsAuthorContainerProps = {
  className?: string;
  gridReference: string;
  isPublicGrid?: boolean;
  isBasket?: boolean;
  noDate?: boolean;
};

const GridsAuthorContainer = ({ noDate, ...ownProps }: GridsAuthorContainerProps) => {
  const { isBasket, gridReference, isPublicGrid } = ownProps;
  const selectedProps = useSelector((state) =>
    legacySelector(state, { gridReference, isPublicGrid, isBasket, noDate }),
  );

  const enhancedProps = useMergeProps({ ownProps, selectedProps });

  return <GridsAuthor {...enhancedProps} />;
};

export default GridsAuthorContainer;
